import './App.css';
import HomePage from './components/HomePage';
import { BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom'; 
import Services from './components/Services';
import Visa from './components/Visa';
import Header from './components/Header';
import DomesticTour from './components/DomesticTour';
import InternationalTour from './components/InternationalTour';
import Flight from './components/Flight';
function App() {
  return (
    <div className="App">
 <Router>
  <Routes>
    <Route path='/' element={ <HomePage/>}/>
    <Route path='/header' element={ <Header/>}/>
    <Route path='/services' element={ <Services/>}/>
    <Route path='/visa' element={ <Visa/>}/>
    <Route path='/domestic-tour' element={ <DomesticTour/>}/>
    <Route path='/international-tour' element={ <InternationalTour/>}/>
    <Route path='/flights' element={ <Flight/>}/>
  </Routes>
 </Router>
   
    </div>
  );
}

export default App;
